
import React from 'react';
import { MapPin, Globe, TrendingUp } from 'lucide-react';
import StarIcon from '../assets/images/icons/start-icon.svg';

const DummyAudienecData = ({
    isPro = false,
    onProClick = () => {}
}) => {

    return (
        <div className="relative w-full">
            {/* Original Content */}
            <div className="element-wrapper text-[12.5px] font-sans">
                <div className="flex flex-wrap justify-between gap-2 mb-[11px]">
                    <div className="title font-bold">
                        Top City<span className="ms-2">🏙️</span>
                    </div>
                    <div className="value font-normal">
                        New Delhi
                    </div>
                </div>
                <div className="flex flex-wrap justify-between gap-2 mb-[11px]">
                    <div className="title font-bold">
                        Top Country<span className="ms-2">🌍</span>
                    </div>
                    <div className="value font-normal">
                        Canada
                    </div>
                </div>
                <div className="flex justify-between gap-2 mb-[15px]">
                    <div className="title font-bold flex items-center">
                        <span className="text-nowrap">Growth Market</span>
                        <span className="ml-2 w-6 h-4 rounded shadow-sm border border-gray-300 overflow-hidden flex items-center justify-center text-xs">
                            +145% growth in Brazil
                        </span>
                    </div>
                    <div className="value font-normal text-right">
                        Trending up
                    </div>
                </div>
            </div>

            {/* Pro Overlay (only shown when isPro is false) */}
            {!isPro && (
                <>
                    {/* Greyed Out Overlay */}
                    <div className="absolute inset-0 bg-gray-200/60 backdrop-blur-[1px] z-10 rounded" />

                    {/* Go Pro Button */}
                    <div className="absolute inset-0 z-20 flex items-center justify-center">
                        <button
                            type="button"
                            className={`btn-custom3 flex items-center gap-2`}
                            onClick={onProClick}
                        >
                            Go Pro
                            <img
                                src={StarIcon}
                                alt="Star"
                                className="h-[20px] w-[20px] min-w-[20px]"
                            />
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default DummyAudienecData;